// src/app/validators/custom-validators.ts
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validador que verifica se o valor do campo é diferente de -1.
 * Retorna um erro 'invalidSelect' se o valor for -1.
 */
export function selectRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value !== -1 ? null : { invalidSelect: true };
  };
}
